import useInitializeUserNewsTipsFilter from './useInitializeUserNewsTipsFilter'
export default useInitializeUserNewsTipsFilter
